<template>
  <clip-loader
    size="70px"
    :color="color"
    style="display: flex;justify-content: center;align-items: center;height:100%;"
  />
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader'

export default {
  name: 'Loading',
  components: {
    ClipLoader
  },
  computed: {
    color () {
      return this.$vuetify.theme.secondary
    }
  }
}
</script>
